




import Vue from "vue"

import { trackPageVisit } from "@/utils/trackEvents"

export default Vue.extend({
  middleware: ["authenticated"],
  setup() {
    trackPageVisit()
  },
  mounted() {
    this.$router.replace(this.localePath(this.$enums.AppPaths.MY_CASES))
  },
})
